import { isInStock } from "./stock.js";
// The price Emporia ADVERTISES: the stored price, before VAT. Owner's
// decision, 2026-10-11: cards, product pages, page titles, structured data
// and the crawler HTML all show this figure, and checkout adds VAT once, as
// its own line (Cart.jsx / Checkout.jsx), only while the server charges it:
// VAT is OFF until Emporia is VAT-registered (owner, 2026-10-20; VAT_RATE,
// backend/app/vat.py). Nothing public may say "including VAT": this figure
// never includes it. For a few hours on 2026-10-11
// (664787c) this returned the VAT-inclusive figure (x1.16) instead; it was
// reverted because the same VAT already appears at checkout. Every public
// price goes through this one function, so the two can never disagree.
export const publicPrice = (base) => Number(base);
export const priceText = (base) => `Ksh ${publicPrice(base).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const publicPath = (product) => `/product/${encodeURIComponent(product.slug || product.id)}`;
export const availability = (p) => isInStock(p)
  ? (p.is_preorder ? "https://schema.org/PreOrder" : "https://schema.org/InStock")
  : "https://schema.org/OutOfStock";

// These are verified manufacturer-to-brand relationships. A supplier, seller,
// model number or marketplace name is not evidence of a product brand.
const BRANDS = {
  "samsung electronics": "Samsung", "sony corporation": "Sony",
  "on one’s way goods co": "ON ONE’S WAY", "beni robotics inc": "Beni",
  "aomais technology co": "Aomais", "ravenow footwear ltd": "RaveNow", "spacex": "Starlink",
  "apple inc": "Apple", "google llc": "Google",
  "beats by dre (apple inc.)": "Beats", "oraimo technology limited": "Oraimo",
};
export const productBrand = (p) => {
  const brand = BRANDS[String(p.manufacturer || "").trim().toLowerCase().replace(/\.+$/, "")];
  // Legacy record uses an Apple model number as manufacturer. Its explicit
  // catalogue name and model corroborate the brand without guessing from ID.
  if (!brand && p.manufacturer === "A3256" && p.product_model === "iPhone 17 Pro" && /^Apple iPhone 17 Pro \(/.test(p.name)) return "Apple";
  return brand || null;
};
export const publicImage = (value) => {
  try { const u = new URL(value); return u.protocol === "https:" ? u.href : null; } catch { return null; }
};
export function catalogueProductSchema(p, canonical) {
  const images = [p.image_url, p.image_url_2, p.image_url_3, p.image_url_4, p.image_url_5].map(publicImage).filter(Boolean);
  const brand = productBrand(p);
  return {
    "@context": "https://schema.org", "@type": "Product", "@id": `${canonical}#product`,
    url: canonical, name: p.name, sku: p.sku || `EM-${p.id}`,
    description: String(p.description || p.name).replace(/\s+/g, " ").trim(),
    ...(images.length ? { image: [...new Set(images)] } : {}),
    ...(brand ? { brand: { "@type": "Brand", name: brand } } : {}),
    offers: {
      "@type": "Offer", url: canonical, priceCurrency: "KES", price: publicPrice(p.price),
      availability: availability(p), itemCondition: "https://schema.org/NewCondition",
      seller: { "@type": "Organization", name: "Emporia", "@id": "https://www.emporia.ke/#organization" },
    },
    ...(p.average_rating > 0 && p.average_rating <= 5 && p.review_count > 0 ? {
      aggregateRating: { "@type": "AggregateRating", ratingValue: p.average_rating, reviewCount: p.review_count },
    } : {}),
  };
}
export function privateRoute(path) {
  return /^\/(account|admin|checkout|cart|inbox|deliveries|orders|wishes|login|register|verify|search|rails|newsletter)(\/|$)/.test(path.split("?")[0])
    || /^\/sell\/(apply|portal)(\/|$)/.test(path);
}

export const categoryProductSlugs = (slug) => [...new Set([...(slug === "fashion-men" ? ["suits", "shirts"] : []), slug])];
